import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { MatchService } from '../services/match.service';

@Injectable()
export class MatchesGuard  {

  constructor(
    private matches: MatchService,
    private router: Router,
  ) { }
  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    try {
      const data = await this.matches.getGame(route.params['id']);
      if (Array.isArray(data) && data.length > 0) {
        return Promise.resolve(true);
      } else {
        this.router.navigate(['/not-found']);
      }
    } catch(e) {
      this.router.navigate(['/not-found']);
    }
  }
}
